<div *ngIf="!isBlocked">
  <div class="dashboard" *ngIf="router.url === '/dashboard'">
    <div class="page-shell">
      <section class="hero-card">
        <div class="hero-copy">
          <div class="welcome-header-row">
            <div class="welcome-heading">
              <span class="welcome-prefix">{{ 'welcomeTo' | translate }}</span>
              <img src="assets/images/defaults/iportal_logo.svg" alt="iPortal logo" class="welcome-logo" />
            </div>
          </div>
          <p class="hero-subtitle">{{ 'newEntry' | translate }}</p>
        </div>
        <div class="shortcut-grid">
          <button class="shortcut-card" (click)="jumpCreateClaim()">
            <span class="shortcut-icon shortcut-claim" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.6 6.72a.48.48 0 0 0-.48-.48H6.48a.48.48 0 1 0 0 .96h8.64a.48.48 0 0 0 .48-.48zM6 10.08a.48.48 0 0 1 .48-.48h8.64a.48.48 0 1 1 0 .96H6.48a.48.48 0 0 1-.48-.48z" fill="currentColor"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.248 19.92H4.56a.96.96 0 0 1-.96-.96V4.56c0-.53.43-.96.96-.96h12.48c.53 0 .96.43.96.96v7.844a4.2 4.2 0 1 1-3.752 7.516zM16.8 4.56a.24.24 0 0 1 .24.24v7.284a4.183 4.183 0 0 0-3.513.876H6.48a.48.48 0 1 0 0 .96h6.192a4.18 4.18 0 0 0-.67 2.4H6.48a.48.48 0 1 0 0 .96h5.66a4.19 4.19 0 0 0 .894 1.68H4.8a.24.24 0 0 1-.24-.24V4.8a.24.24 0 0 1 .24-.24h12zM15.6 16.8a.48.48 0 1 0 .96 0v-2.88a.48.48 0 1 0-.96 0v2.88zm.96 1.44a.48.48 0 1 1-.96 0 .48.48 0 0 1 .96 0z" fill="currentColor"></path>
              </svg>
            </span>
            <span class="shortcut-label">Claim</span>
          </button>
          <button class="shortcut-card" (click)="jumpCreateCompany()">
            <span class="shortcut-icon shortcut-company"></span>
            <span class="shortcut-label">{{ 'newCompany' | translate }}</span>
          </button>
          <button class="shortcut-card" (click)="jumpCreateVessel()">
            <span class="shortcut-icon shortcut-vessel"></span>
            <span class="shortcut-label">{{ 'newVessel' | translate }}</span>
          </button>
          <button class="shortcut-card" (click)="jumpCreateUser()">
            <span class="shortcut-icon shortcut-user"></span>
            <span class="shortcut-label">{{ 'newUser' | translate }}</span>
          </button>
        </div>
      </section>

      <section class="summary-grid">
        <article class="summary-card">
          <div class="summary-card-header">
            <h2>{{ 'yourClaimStatus' | translate }}</h2>
            <span class="summary-pill">{{ totalClaims }}</span>
          </div>
          <div class="chart-wrap">
            <canvas baseChart [type]="'doughnut'" [data]="claimChartData" [options]="chartConfig"></canvas>
            <div class="chart-center-text">
              <strong>{{ totalClaims }}</strong>
              <span>{{ 'tickets' | translate }}</span>
            </div>
          </div>
          <div class="summary-list">
            <div class="summary-item"><span class="status-dot new"></span>{{ 'claimStatusNew' | translate }} <strong>{{ claimSummary.New }}</strong></div>
            <div class="summary-item"><span class="status-dot open"></span>{{ 'claimStatusOpen' | translate }} <strong>{{ claimSummary.Open }}</strong></div>
            <div class="summary-item"><span class="status-dot resolved"></span>{{ 'claimStatusResolved' | translate }} <strong>{{ claimSummary.Resolved }}</strong></div>
            <div class="summary-item"><span class="status-dot closed"></span>{{ 'claimStatusClosed' | translate }} <strong>{{ claimSummary.Closed }}</strong></div>
          </div>
        </article>
        <article class="summary-card">
          <div class="summary-card-header">
            <h2>{{ 'overallClaimStatus' | translate }}</h2>
            <span class="summary-pill">{{ overallTotalClaims }}</span>
          </div>
          <div class="chart-wrap">
            <canvas baseChart [type]="'doughnut'" [data]="overallChartData" [options]="chartConfig"></canvas>
            <div class="chart-center-text">
              <strong>{{ overallTotalClaims }}</strong>
              <span>{{ 'tickets' | translate }}</span>
            </div>
          </div>
          <div class="summary-list">
            <div class="summary-item"><span class="status-dot new"></span>{{ 'claimStatusNew' | translate }} <strong>{{ overallClaimSummary.New }}</strong></div>
            <div class="summary-item"><span class="status-dot open"></span>{{ 'claimStatusOpen' | translate }} <strong>{{ overallClaimSummary.Open }}</strong></div>
            <div class="summary-item"><span class="status-dot resolved"></span>{{ 'claimStatusResolved' | translate }} <strong>{{ overallClaimSummary.Resolved }}</strong></div>
            <div class="summary-item"><span class="status-dot closed"></span>{{ 'claimStatusClosed' | translate }} <strong>{{ overallClaimSummary.Closed }}</strong></div>
          </div>
        </article>
      </section>
    </div>
  </div>
</div>
<div *ngIf="isBlocked">
  <app-not-registered></app-not-registered>
</div>
<div class="components">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
